import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { DeviceOptions } from '../enums/device-options.enum';

@Component({
  selector: 'app-device-setup-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterOutlet],
  templateUrl: './device-setup-menu.component.html',
  styleUrl: './device-setup-menu.component.scss',
})
export class DeviceSetupMenuComponent {
  selectedItem: string = 'device-setup';
  item = DeviceOptions;

  constructor(private router: Router) {}

  toggleModal(item: DeviceOptions) {
    this.selectedItem = item;
    this.router.navigate([item]);
  }
}
